import type { LeadId } from "@gs/core/domain/Lead/Lead";
import type { LeadMarkers } from "@gs/core/domain/LeadMarkers/LeadMarkers";
import { createDomainStore } from "../_utils/createDomainStore";

export const [leadMarkersStore, useLeadMarkersStore] = createDomainStore<LeadMarkers, LeadId>("leadMarkers");
